import { useMutation } from '@tanstack/react-query'

import { emailService } from '@/services/email-service'
import { useAuthStore } from '@/stores/auth-store'

export function useSendPosUserTestEmail() {
  const { selectedSystem } = useAuthStore()

  return useMutation({
    mutationFn: (email: string) => {
      if (!selectedSystem) throw new Error('No system selected')
      return emailService.sendPosUserTestEmail(selectedSystem, email)
    },
  })
}
